<template>
<div class="bg-light py-4" style="min-height: 100vh;">
  <div class="container" v-if="schoolData">
    <div class="pt-1 pb-4">
      <div class="d-flex align-items-center justify-content-center mt-auto">
        <img v-if="schoolData.name" :src="schoolData.logo" :alt="schoolData.name" style="width:50px;" />
        <img v-else src="/resources/images/air-logo.png" alt="neoskool" />
        <div class="ml-3">
          <div class="h5 font-weight-bold text-dark mb-0">{{ schoolData.name ? schoolData.name : 'skoolsync-M'}}</div>
          <div
            class="font-size-12 text-gray-6"
          >{{ schoolData.contact ? `${schoolData.contact.address}, ${schoolData.contact.city}` : ''}}</div>
        </div>
      </div>
    </div>
    <!-- <a-divider /> -->
    <div class="mt-3">
      <a-spin :spinning="loading">
        <div>
          <div class="card shadow-sm">
            <div class="card-body" style="min-height:70vh;">
              <div class="air__utils__heading">
                <div class="row align-items-center">
                  <div class="col-sm-8">
                    <h5>Online Application for course/class: <span class="font-weight-bold">{{data ? data.school_class.name : ''}}</span> for session: <span class="font-weight-bold">{{data ? data.session.name : ''}}</span></h5>
                  </div>
                  <div class="col-md-4 text-right">
                    <button v-if="applicant.app_form_token" class="btn btn-dark" @click="handleLogout">Logout</button>
                  </div>
                </div>
              </div>

              <div v-if="data && !applicant.app_form_token" class="mt-4">
                <p class="font-italic mb-1 font-size-18">Please <strong>Login</strong> if you already have an <strong>Application id</strong> and <strong>Password</strong>.</p>
                <p class="font-italic h5">Else, you can carry on with the application process by registering a new account in the <strong>Register</strong> section.</p>

                <div class="row mt-4">
                  <div class="col-md-8 col-lg-6 order-2 order-md-1">
                    <a-tabs default-active-key="1" >
                      <a-tab-pane key="1" force-render>
                        <span slot="tab" class="font-size-18 font-weight-bold">
                          Login
                        </span>
                        <ApplicationLogin :schoolId="schoolData ? schoolData.id : null" :formId="applicationFormId"/>
                      </a-tab-pane>
                      <a-tab-pane key="2" force-render>
                        <span slot="tab" class="font-size-18 font-weight-bold">
                          Register
                        </span>
                        <template v-if="data && moment(data.end_date).isAfter(moment())">
                          <ApplicationRegister :schoolId="schoolData ? schoolData.id : null" :formId="applicationFormId"/>
                        </template>
                        <template v-else>
                          <p class="py-4 mb-0 font-weight-bold text-danger">The application is closed!</p>
                        </template>
                      </a-tab-pane>
                    </a-tabs>
                  </div>
                  <div v-if="data && data.selection_criteria" class="col-md-4 col-lg-6 order-1 order-md-2">
                    <div class="p-3 neo-bg-info" style="height: 100%;">
                      <p class="font-weight-bold">Selection Criteria:</p>
                      <div class="font-weight-bold font-size-18">
                        {{data.selection_criteria}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="applicant.app_form_token">
                <div class="row justify-content-between mt-4">
                  <div class="col-md-12">
                    <div v-if="data">
                      <ApplicationForm :data="data"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </div>

    <!-- <pay-student-fees @paid="handleFeesPaid" :schoolData="schoolData"/> -->
    <!-- <student-fee-payment /> -->
  </div>
</div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import ApplicationLogin from '@/components/system/ApplicationAuth/Login/index'
import ApplicationRegister from '@/components/system/ApplicationAuth/Register/index'
import ApplicationForm from '@/components/public/ApplicationForm/index'

import { find } from 'lodash'

const subdomain = window.location.host.split('.')[0]

export default {
  components: {
    ApplicationLogin,
    ApplicationRegister,
    ApplicationForm,
  },
  mounted: function() {
    this.getSchoolData()
  },
  data: function() {
    return {
      dateFormat: 'll',
      schoolData: null,
      data: null,
      loading: false,
      step: 1,
    }
  },
  computed: {
    ...mapState(['settings', 'applicant']),
    applicationFormId: function() {
      return this.$route.params.formId
    },
  },
  methods: {
    moment,
    find,
    getApplicationForms: function(formId) {
      this.loading = true
      this.$http.get(`/api/application-form/single/${formId}`, {
        params: {
          school_id: this.schoolData.id,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
      }).catch(() => {
        this.$applicantAuth.logout()
      })
    },
    getSchoolData: function() {
      this.loading = true
      this.$http.get(`/api/school/subdomain/${subdomain}`)
        .then(({ data }) => {
          this.loading = false
          if (data.data.online_application) {
            this.schoolData = data.data
            this.getApplicationForms(this.$route.params.formId)
          } else {
            this.$router.push({ name: '404' })
          }
        })
    },
    handleFormClick(formId) {
      this.$router.push({ name: 'onlineapplication', params: { formId: formId } })
    },
    handleLogout() {
      this.$applicantAuth.logout()
    },
  },
}
</script>
